/**
 * Form Modal System - Enhanced Modal Template for Forms
 *
 * Complete form modal solution with:
 * - Core universal template (EnhancedFormModal)
 * - Preset wrappers (Quick, Standard, Advanced)
 * - Helper hooks (useFormModal, useDirtyCheck)
 * - Validated components (ValidatedInput, ValidatedTextarea)
 *
 * @module form-modal
 */

// ============================================================================
// Core Template
// ============================================================================

export { EnhancedFormModal, MOBILE_MODAL_BODY_HEIGHT } from './enhanced-form-modal';
export type {
  EnhancedFormModalProps,
  ModalSize,
  ResponsiveSize,
  PreviewPosition,
  MotionPreset,
} from './enhanced-form-modal';

// ============================================================================
// Preset Wrappers
// ============================================================================

export { QuickFormModal } from './presets/quick-form-modal';
export type { QuickFormModalProps } from './presets/quick-form-modal';

export { StandardFormModal } from './presets/standard-form-modal';
export type { StandardFormModalProps } from './presets/standard-form-modal';

export { AdvancedFormModal } from './presets/advanced-form-modal';
export type { AdvancedFormModalProps } from './presets/advanced-form-modal';

// ============================================================================
// Hooks
// ============================================================================

export { useFormModal } from './hooks/use-form-modal';
export type { UseFormModalOptions, UseFormModalReturn } from './hooks/use-form-modal';

export { useDirtyCheck, useDirtyCheckWithForm } from './hooks/use-dirty-check';
export type { UseDirtyCheckOptions, UseDirtyCheckReturn } from './hooks/use-dirty-check';

// ============================================================================
// Validated Components
// ============================================================================

export { ValidatedInput } from './components/validated-input';
export type { ValidatedInputProps } from './components/validated-input';

export { ValidatedTextarea } from './components/validated-textarea';
export type { ValidatedTextareaProps } from './components/validated-textarea';
